<ng-container *transloco="let t;">
  <div class="content-wrapper container-xxl p-0">
    <div class="center-half-page">
      <div class="content-header invite-page-header">
        <h1 class="mb-0">{{t('Lets started message on team invitation page(Lets get started) Lets get started')}}
          {{ name }}.</h1>
        <p class="subtitle-paragraph mb-0">Bring your team, SimpleSign works best together.</p>
      </div>
      <div class="center-container">
        <p class="invite-team-paragraph">{{t('small description about simple sign on team intivation
          page(description on team invitation page) Using SimpleSign helps signing documents faster and streamline
          your contract management processes, just through one platform.')}}</p>
        <div id="email-list" class="email-list-box">
          <div id="email-item" class="email-item">
            <span class="item" *ngFor="let email of emailList; let i = index">
              <span>{{ email }}</span>
              <div class="email-remove" (click)="removeEmail(i)">
                <svg class="cross-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <circle cx=" 50%" cy="50%" r="10" fill="#5899f4" />
                  <path d="M17 17L7 7.00002M17 7L7.00001 17" stroke="white" stroke-width="4" stroke-linecap="round"
                    transform="scale(0.5) translate(12, 12)" />
                </svg>
              </div>
            </span>
            <span class="item-input">
              <input type="email" (keydown)="onEmailSetKeyDown($event)" [(ngModel)]="emailSet"
                placeholder="Add emails" />
              <span *ngIf="emailSetInvalid" class="email-error">{{t('invalid email address on team intivation page
                (error message invalid email address) Email must be a valid email address')}}</span>
              <span *ngIf="error" class="email-error">{{error}}</span>
            </span>
          </div>
        </div>
        <div class="instruction-text">
          <small>
            {{t('invite team input instruction text (invite team page) - add email by enter')}}
          </small>
        </div>
        <button (click)="submitTeamInvitation()" type="submit" class="btn btn-primary btn-lg btn-next" rippleEffect
          [disabled]="emailList.length == 0 || loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
          <span class="align-middle d-sm-inline-block ">{{t('invite and continue button on team invitation page
            (invite team button) Invite and Continue')}}</span>
        </button>
      </div>
      <div class="skip-invite-box" (click)="skipTeamInvitation()" [class.disabled]="loading">
        <a class="skip-invite-text">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
          {{t('skip invite team page (skip team invitation functionality text) Not Now')}}
        </a>
      </div>
    </div>
  </div>
</ng-container>